import React from 'react';
import HighlightParagraph from '@catalogo/ui-americanas-desktop-questions-and-answers-list/src/components/highlight-paragraph';
import SvgQuestion from '@catalogo/ui-americanas-mobile-qna/src/svgs/question.svg';
import { Owner, QuestionText, QuestionWrapper, SvgQuestionBox, Wrapper } from './styled';
import AnswerBox from '../AnswerBox';
import { IQuestionProps } from '../../../types';

export const Question = ({ question, term, totalTermFound, isLast, isDesk }: IQuestionProps) => (
  <QuestionWrapper className={isLast ? 'last' : ''}>
    <Wrapper isDesk={isDesk}>
      <SvgQuestionBox isDesk={isDesk}>
        <SvgQuestion />
      </SvgQuestionBox>
      <div>
        <QuestionText isDesk={isDesk}>
          <HighlightParagraph term={term} text={question?.question} totalTermFound={totalTermFound} />
        </QuestionText>
        <Owner>
          por {question?.owner?.name} em {question?.createdAt}
        </Owner>
      </div>
    </Wrapper>
    <AnswerBox isDesk={isDesk} answer={question?.answer} question={question} />
  </QuestionWrapper>
);

export default Question;
